const isDate = (value) => Object.prototype.toString.call(value) === "[object Date]";
export {
  isDate as i
};
//# sourceMappingURL=is-date.js.map
